// src/utils/alertUtils.js
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

// Confirm deletion
export const confirmDelete = async (title = 'Are you sure?', text = 'This action cannot be undone.') => {
  return await MySwal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
  });
};

// Success message
export const showSuccess = (title = 'Success', text = 'Operation completed successfully') => {
  return MySwal.fire({
    icon: 'success',
    title,
    text,
  });
};

// Error message
export const showError = (title = 'Error', text = 'Something went wrong') => {
  return MySwal.fire({
    icon: 'error',
    title,
    text,
  });
};
